import { render, staticRenderFns } from "./GestioneAttivitaClientiListSelectModal.vue?vue&type=template&id=47fa33c4"
import script from "./GestioneAttivitaClientiListSelectModal.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaClientiListSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports